var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-main', [_c('v-navigation-drawer', {
    attrs: {
      "right": "",
      "app": "",
      "width": 300
    }
  }, [_c('h2', {
    staticClass: "ma-2"
  }, [_vm._v(" " + _vm._s(_vm.workspace) + " ")]), _c('v-divider'), _vm._l(_vm.workspaceInfo, function (_ref) {
    var title = _ref.title,
        data = _ref.data,
        network = _ref.network;
    return _c('v-card', {
      key: title,
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-title', [_vm._v(" " + _vm._s(title) + " ")]), _c('v-divider'), _c('v-card-text', [_c('v-list', {
      staticStyle: {
        "overflow-y": "auto"
      },
      attrs: {
        "nav": "",
        "max-height": "20vh"
      }
    }, _vm._l(data, function (name) {
      return _c('v-list-item', {
        key: name,
        staticStyle: {
          "min-height": "30px"
        },
        attrs: {
          "dense": "",
          "to": _vm.detailLink(name, network)
        }
      }, [_c('v-list-item-icon', {
        staticClass: "ma-0 mt-1"
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v(" " + _vm._s(network ? "mdi-chart-timeline-variant" : "mdi-table") + " ")])], 1), _vm._v(" " + _vm._s(name) + " ")], 1);
    }), 1)], 1)], 1);
  })], 2), _c('v-card', {
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Run AQL Query")]), _c('v-divider'), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-textarea', {
    staticStyle: {
      "font-family": "monospace",
      "font-size": "0.9em"
    },
    attrs: {
      "height": "500px",
      "no-resize": "",
      "label": "Enter AQL Query",
      "solo": "",
      "loading": _vm.loading,
      "error-messages": _vm.queryErrorMessage
    },
    model: {
      value: _vm.query,
      callback: function callback($$v) {
        _vm.query = $$v;
      },
      expression: "query"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "ml-2 overflow-y-auto",
    attrs: {
      "height": "500px"
    }
  }, [_c('v-card-title', [_vm._v("Bind Variables")]), _c('v-card-subtitle', [_vm._v("Any values that must be bound can be input here (values must be strings)")]), _c('v-list', _vm._l(_vm.bind_var_keys, function (key, index) {
    return _c('v-list-item', {
      key: key
    }, [_c('v-row', {
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('v-text-field', {
      staticClass: "mx-1",
      attrs: {
        "readonly": "",
        "flat": "",
        "solo": "",
        "value": key
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('v-text-field', {
      staticClass: "mx-1",
      attrs: {
        "outlined": ""
      },
      model: {
        value: _vm.bind_var_values[index],
        callback: function callback($$v) {
          _vm.$set(_vm.bind_var_values, index, $$v);
        },
        expression: "bind_var_values[index]"
      }
    })], 1)], 1)], 1);
  }), 1)], 1)], 1)], 1), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "error",
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.lastQueryResults = null;
      }
    }
  }, [_vm._v(" Clear Results ")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.runQuery
    }
  }, [_vm._v(" Run Query ")])], 1)], 1), _vm.lastQueryResults !== null ? _c('v-card', {
    staticClass: "mt-5"
  }, [_c('v-card-title', [_vm._v("Query Results")]), _c('vue-json-pretty', {
    attrs: {
      "data": _vm.lastQueryResults,
      "highlight-mouseover-node": "",
      "collapsed-on-click-brackets": "",
      "virtual": ""
    }
  })], 1) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }